module.exports = __webpack_public_path__ + "static/img/merchant_new_1.4755dd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/uupay/images/merchant_new_1.png
// module id = KvlM
// module chunks = 8